import { format } from 'date-fns';
import { postRequest } from '../../../core/apiRequests';
import { clientbookApi } from '../../../core/clientbook-api';
import store from '../../../core/store';

export const updatedAiAssistantViewDate = (userId, setAuthEdison = () => {}) => {
  const today = new Date();
  const date = `${today.getFullYear()}${today.getMonth() + 1}${today.getDate()}`;
  setAuthEdison(date);
  const reqObj = {
    params: ['associates', userId, 'edisonViewDate'],
    query: {
      hasSeenDate: date,
    },
    loadingStatusOff: true,
  };
  (async () => {
    await postRequest(reqObj);
  })();
};

export const updateVendorItemViewDate = async (vendorRecommendations, eventSource, eventType) => {
  if (!vendorRecommendations?.length) return;
  const { merchantId, userId: associateId } = store.getState().auth;
  const eventDateTime = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
  await Promise.all(
    vendorRecommendations.map(({ vendorId, mpn }) =>
      clientbookApi.post({
        url: '/events/vendor',
        data: {
          merchant_id: merchantId,
          associate_id: associateId,
          vendor_id: vendorId,
          mpn,
          event_type: eventType,
          event_date_time: eventDateTime,
          event_source: eventSource,
        },
      }),
    ),
  );
};
